import { apiUrl, isSuccess } from "./apiClient";
import httpOption from "./httpOption";

export function getVideoIdFromAlias(alias) {
  const options = httpOption.GET();
  options.headers["accept-language"] =
    options.headers["accept-language"] || "en";

  return fetch(apiUrl(`/videos/id/${alias}`), options).then((response) => {
    if (isSuccess(response)) {
      return response.json();
    }
    throw response;
  });
}

export async function getQumuSources(qumuId) {
  const url = `https://video-toyota.qumucloud.com/api/2.2/rest/widgets/${qumuId}.json`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const data = await response.json();

  if (!data.kulus || data.kulus.length === 0) {
    throw new Error("No kulu data available");
  }

  const kulu = data.kulus[0];
  const {
    guid,
    title,
    duration,
    player,
    thumbnail,
    media,
    metadata,
    captionTracks,
    chapters,
  } = kulu;
  const description = metadata?.find(
    (obj) => obj?.title === "Description",
  )?.value;
  // Find the media variants with the specified format codes
  const mobileVariant = media?.variants?.find(
    (variant) => variant.formatCode === "mobile_mp4",
  );
  const hlsVariant = media?.variants?.find(
    (variant) => variant.formatCode === "hls_default",
  );
  const canonicalVariant = media?.variants?.find(
    (variant) => variant.formatCode === "canonical",
  );

  let mobileSrc = mobileVariant?.url;
  if (mobileSrc) {
    const url = new URL(mobileSrc);
    // Insert or update the 'delivery' parameter to 'CDN_DOWNLOAD'
    url.searchParams.set("delivery", "CDN_DOWNLOAD");
    mobileSrc = url.toString();
  }
  // Extract caption guid for language code 'en'
  let captions = null;
  if (Array.isArray(captionTracks)) {
    const enTrack = captionTracks.find((track) => track.languageCode === "en");
    if (enTrack) {
      captions = `https://video-toyota.qumucloud.com/api/2.2/rest/kulus/${guid}/captiontracks/${enTrack.guid}.vtt`;
    }
  }
  // Qumu chapters: [{ guid, title, time (ms from start), hidden }]. Drop hidden ones and
  // keep only the fields the player needs. Consumed by VideoJSComponent behind a feature flag.
  const visibleChapters = (chapters ?? [])
    .filter((c) => !c.hidden)
    .map((c) => ({ title: decodeHtmlEntities(c.title), time: c.time }));
  return {
    id: guid,
    title: decodeHtmlEntities(title),
    duration,
    shareLink: player,
    poster: thumbnail?.url,
    mobileSrc,
    hlsSrc: hlsVariant?.url,
    canonicalSrc: canonicalVariant?.url,
    description: description,
    captions,
    chapters: visibleChapters,
  };
}

function decodeHtmlEntities(str) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}
